export const ROUTES = {
  home: '/access/home',
  access: '/access/:token',
  error: '/access/error',
  assign: '/access/assign',
  mode: '/access/mode',
}
